import { HStack, IconButton, Spacer, Spinner } from '@chakra-ui/react'
import type { FC } from 'react'

import WorkDeleteButton from '@app/pages/entities/components/workDeleteButton'
import Can from '@app/shared/authorization/can'
import ICON_MAP from '@app/utils/iconMap'
import type { Entity } from '@graphql/types'

interface Props {
  data: Entity
}

const WorkListActions: FC<Props> = ({ data }) => (
  <HStack>
    <Spacer />
    <Can I="update" a="metric">
      <WorkDeleteButton workId={data.id}>
        {(props) => (
          <IconButton aria-label="Delete work" variant="ghost">
            {props?.loading ? <Spinner size="xs" /> : <ICON_MAP.Delete />}
          </IconButton>
        )}
      </WorkDeleteButton>
    </Can>
  </HStack>
)

export default WorkListActions
